import React from 'react';
import { Modal as AntModal } from 'antd';
import styled from 'styled-components';

import { Icon } from 'ensightful-koala-ui';

const StyledIcon = styled(Icon)`
    padding: 0px;
    width: 14px;
    height: 14px;
    right: 30px;
    top: 36px;
    position: absolute;
`;

const Modal = (props) => {
    return (
        <AntModal
            {...props}
            footer={props?.footer ? props.footer : null}
            closeIcon={<StyledIcon kind={'close'} iconColor={'black'} />}
        />
    );
};

Modal.confirm = AntModal.confirm;

export default Modal;
